
import Popup from '@/components/Popup/popup.component.vue'

export default {
    name: 'Home',
    components: {
        Popup
    },
    data() {
        return {
            reach: "https://img.icons8.com/ios/96/ffffff/helping-hand.png",
            teach: "https://img.icons8.com/ios/100/ffffff/teacher.png",
            train: "https://img.icons8.com/ios/52/ffffff/statistics.png",
            send: "https://img.icons8.com/ios/64/ffffff/up-right-arrow.png",
            setter: Array(),
        }
    },
    methods: {
        set(item) {
            let temp = new Array();
            let image;
            switch (item.toLowerCase()) {
                case "reach":
                    image = this.reach;
                    break;
                case "teach":
                    image = this.teach;
                    break;
                case "train":
                    image = this.train;
                    break;
                case "send":
                    image = this.send;
                    break;
                default:
                    break;
            }
            temp.push(item);
            temp.push(image)
            this.setter = temp;
        },
        join() {
            // this.$router.push({name: 'Join'})
        }
    }

}